import { GRAMS_PER_POUND } from '@/shared/dictionaries/unitConversion.dictionary'

const SMALL_WEIGHT_LBS_THRESHOLD = 0.1

export function formatWeightLbs(grams: number): string {
  const lbs = grams / GRAMS_PER_POUND
  const decimals = lbs > 0 && lbs < SMALL_WEIGHT_LBS_THRESHOLD ? 2 : 1

  return `${lbs.toFixed(decimals)} lbs`
}

export function formatDimensionsCm(lengthCm: number, widthCm: number, heightCm: number): string {
  return `${lengthCm} × ${widthCm} × ${heightCm} cm`
}
